import { useEffect, useState } from 'react';
import { canRenewConsent } from '../helpers/consent';

/**
 * Whether Cookiebot has loaded and can reopen its consent banner.
 *
 * Cookiebot arrives via GTM, so it is not there on first paint — and never at
 * all locally, where the GTM block is skipped in debug. Anything offering to
 * change consent should render nothing until this is true, rather than show a
 * link that cannot do anything.
 * @returns {boolean}
 */
const useCookiebotAvailable = () => {
  const [available, setAvailable] = useState(canRenewConsent());

  useEffect(() => {
    if (available) return undefined;

    const check = () => setAvailable(canRenewConsent());
    window.addEventListener('CookiebotOnLoad', check);
    window.addEventListener('CookiebotOnConsentReady', check);

    return () => {
      window.removeEventListener('CookiebotOnLoad', check);
      window.removeEventListener('CookiebotOnConsentReady', check);
    };
  }, [available]);

  return available;
};

export default useCookiebotAvailable;
